import {supabase} from '../supabase/client.js';

const BUSINESS_FEATURE_PLANS = new Set([
  'mileage',
  'solo',
  'entrepreneur',
  'portfolio',
  'trial_expired'
]);

export async function getBusinessFeaturePlan(businessId, client = supabase) {
  if (!client) throw new Error('Supabase is not configured.');
  if (!businessId) throw new Error('Choose a Business before checking feature access.');

  const {data, error} = await client.rpc('get_business_feature_plan', {
    p_business_id: businessId
  });

  if (error) throw error;
  if (!BUSINESS_FEATURE_PLANS.has(data)) {
    throw new Error('Unable to verify feature access for this Business.');
  }
  return data;
}

export async function hasGooglePlayReviewerEntitlement(businessId, client = supabase) {
  if (!client) throw new Error('Supabase is not configured.');
  if (!businessId) return false;

  const {data, error} = await client.rpc('has_google_play_review_entitlement', {
    p_business_id: businessId
  });

  if (error) throw error;
  return data === true;
}

export async function hasComplimentaryPortfolioAccess(businessId, client = supabase) {
  if (!client) throw new Error('Supabase is not configured.');
  if (!businessId) throw new Error('Choose a Business before checking billing access.');

  const {data, error} = await client.rpc('has_complimentary_portfolio_access', {
    p_business_id: businessId
  });

  if (error) throw error;
  return data === true;
}
